"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.erc721CollectionV2 = void 0;
const schemas_1 = require("@dcl/schemas");
const abis_1 = require("../abis");
exports.erc721CollectionV2 = {
    [schemas_1.ChainId.MATIC_MUMBAI]: {
        version: '2',
        abi: abis_1.abis.ERC721CollectionV2,
        address: '',
        name: 'Decentraland Collection',
        chainId: schemas_1.ChainId.MATIC_MUMBAI
    },
    [schemas_1.ChainId.MATIC_MAINNET]: {
        version: '2',
        abi: abis_1.abis.ERC721CollectionV2,
        address: '',
        name: 'Decentraland Collection',
        chainId: schemas_1.ChainId.MATIC_MAINNET
    }
};
//# sourceMappingURL=erc721CollectionV2.js.map